import memoize from 'lru-memoize';
import {linuxUserRules, createValidator, required, maxLength, email, noSpecialChars, noSpaces, minLength} from 'utils/validation';

import form from './form.json';

const createGroupValidation = createValidator({
  name: [required],
});

export default memoize(10)(createGroupValidation);
